var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1408 0V4.50737H0.859192V0H21.1408ZM1.30988 6.31001H20.69C20.69 11.6617 16.3513 16.0001 10.9997 16.0001C5.64798 16.0001 1.30988 11.6617 1.30988 6.31001ZM8.69004 13.1204C8.69004 14.4836 9.79535 15.5889 11.1584 15.5889C12.5219 15.5889 13.627 14.4836 13.627 13.1204V9.56753C13.627 8.204 12.5219 7.09865 11.1584 7.09865C9.7953 7.09865 8.69004 8.204 8.69004 9.56753V13.1204ZM11.1011 14.0463C12.1378 14.0463 12.9783 13.2056 12.9783 12.1689C12.9783 11.132 12.1378 10.2914 11.1011 10.2914C10.0641 10.2914 9.22379 11.1319 9.22379 12.1689C9.22384 13.2056 10.0641 14.0463 11.1011 14.0463Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.b422c2c7ba1e62b2ac3afd03ebb5f4f3.svg";
export { ForwardRef as ReactComponent };